<template>
  <div class="membership">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.newMembership') }}
        </h3>
      </div>
      <div class="box-body">
        <form-membership />
      </div>
    </div>
  </div>
</template>

<script>
import FormMembership from './Form'
export default {
  name: 'Create',
  components: { FormMembership },
  metaInfo () {
    return {
      title: this.$t('string.addNewMembership'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
